export const timezoneListCustom  = {
  0: "Etc/UTC",
  1: "Asia/Tehran",
  2: "America/New_York",
}